import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Breadcrumb from "../Breadcrumb";
import BottomNavigation from "./BottomNavigation"; // Import new component
import { LayoutContainer } from "../UI";
import { NotificationsProvider } from "../../context/NotificationsContext";
import GlobalNotificationsDropdown from "../GlobalNotificationsDropdown";
import MaintenanceBanner from "../MaintenanceBanner";

const Layout = ({ children }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isSupportRoute = location.pathname.startsWith("/support");

  // Закрываем мобильное меню при изменении маршрута
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <NotificationsProvider>
      <div className="layout-container">
        {/* Основной контент — центрируется в оставшейся области */}
        <main
          className={`main-content pb-safe ${mobileMenuOpen ? "mobile-menu-open" : ""} ${isSupportRoute ? "support-fullscreen" : ""}`}
        >
          {/* Add pb-20 to prevent content from being hidden behind bottom nav on mobile */}
          <LayoutContainer
            className={`relative flex flex-col flex-1 ${isSupportRoute ? "max-w-full !px-0 !pb-0" : "pb-20 lg:pb-0"}`}
          >
            {!isSupportRoute && (
              <>
                {/* Breadcrumbs shown only on desktop now */}
                <div className="hidden lg:flex breadcrumb-wrapper-container mb-1 md:mb-2 items-center min-h-[48px]">
                  <div className="flex-1 min-w-0 flex items-center">
                    <Breadcrumb />
                  </div>
                </div>

                <div className="mb-4 md:mb-5">
                  <MaintenanceBanner />
                </div>
              </>
            )}

            {children
              ? React.cloneElement(children, { setMobileMenuOpen })
              : (
                <Outlet context={{ mobileMenuOpen, setMobileMenuOpen }} />
              )}
          </LayoutContainer>
        </main>

        {/* Боковая панель — отдельно, не участвует в центрировании */}
        <Sidebar
          mobileMenuOpen={mobileMenuOpen}
          setMobileMenuOpen={setMobileMenuOpen}
        />

        {/* Bottom Navigation for Mobile */}
        <BottomNavigation
          mobileMenuOpen={mobileMenuOpen}
          setMobileMenuOpen={setMobileMenuOpen}
        />

        {/* Глобальный dropdown уведомлений на уровне Layout */}
        <GlobalNotificationsDropdown />
      </div>
    </NotificationsProvider>
  );
};

export default Layout;
